var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

$(document).ready(function () {

    // Scroll Header
    $(window).scroll(function () {
        var sticky = $('#shopify-section-header'),
            scroll = $(window).scrollTop();

        if (scroll >= 10) sticky.addClass('fixed'), sticky.addClass('fixed');
        else sticky.removeClass('fixed');
    });

    $(".js-mobile-nav-toggle").click(function () {
        $('body').toggleClass("mobilemenu-opened");
    });

    // Scroll Header End
})

// ACCORDION
$(function () {
    var Accordion = function (el, multiple) {
        this.el = el || {};
        this.multiple = multiple || false;

        var links = this.el.find('.link');
        // Event
        links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
    }

    Accordion.prototype.dropdown = function (e) {
        var $el = e.data.el;
        $this = $(this),
            $next = $this.next();

        $next.slideToggle();
        $this.parent().toggleClass('open');

        if (!e.data.multiple) {
            $el.find('.submenu').not($next).slideUp().parent().removeClass('open');
        }
        ;
    }

    var accordion = new Accordion($('.accordion'), false);
});
// ACCORDION END

// ACCORDION FOOTER
$(function () {
    var Accordion = function (el, multiple) {
        this.el = el || {};
        this.multiple = multiple || false;

        var links = this.el.find('.link');
        // Event
        links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
    }

    Accordion.prototype.dropdown = function (e) {
        var $el = e.data.el;
        $this = $(this),
            $next = $this.next();

        $next.slideToggle();
        $this.parent().toggleClass('open');

        if (!e.data.multiple) {
            $el.find('.submenu').not($next).slideUp().parent().removeClass('open');
        }
        ;
    }

    var accordion = new Accordion($('.accordion__footer'), false);
});
// ACCORDION FOOTER END

//TAB
$(document).ready(function () {
    $('.tab-a').click(function () {
        $(".tab").removeClass('tab-active');
        $(".tab[data-id='" + $(this).attr('data-id') + "']").addClass("tab-active");
        $(".tab-a").removeClass('active-a');
        $(this).parent().find(".tab-a").addClass('active-a');
    });
});
//END TAB

//Before After

// Call & init
$(window).load(function () {
    $('.ba-slider').each(function () {
        var cur = $(this);
        // Adjust the slider
        var width = cur.width() + 'px';
        cur.find('.resize img').css('width', width);
        cur.find('.resize img').css('display', 'block');
        // Bind dragging events
        drags(cur.find('.handle'), cur.find('.resize'), cur);
    });
});

// Update sliders on resize.
// Because we all do this: i.imgur.com/YkbaV.gif
$(window).resize(function () {
    $('.ba-slider').each(function () {
        var cur = $(this);
        var width = cur.width() + 'px';
        cur.find('.resize img').css('width', width);
    });
});

function drags(dragElement, resizeElement, container) {

    // Initialize the dragging event on mousedown.
    dragElement.on('mousedown touchstart', function (e) {

        dragElement.addClass('draggable_before');
        resizeElement.addClass('resizable');

        // Check if it's a mouse or touch event and pass along the correct value
        var startX = (e.pageX) ? e.pageX : e.originalEvent.touches[0].pageX;

        // Get the initial position
        var dragWidth = dragElement.outerWidth(),
            posX = dragElement.offset().left + dragWidth - startX,
            containerOffset = container.offset().left,
            containerWidth = container.outerWidth();

        // Set limits
        minLeft = containerOffset + 10;
        maxLeft = containerOffset + containerWidth - dragWidth - 10;

        // Calculate the dragging distance on mousemove.
        dragElement.parents().on("mousemove touchmove", function (e) {

            // Check if it's a mouse or touch event and pass along the correct value
            var moveX = (e.pageX) ? e.pageX : e.originalEvent.touches[0].pageX;

            leftValue = moveX + posX - dragWidth;

            // Prevent going off limits
            if (leftValue < minLeft) {
                leftValue = minLeft;
            } else if (leftValue > maxLeft) {
                leftValue = maxLeft;
            }

            // Translate the handle's left value to masked divs width.
            widthValue = (leftValue + dragWidth / 2 - containerOffset) * 100 / containerWidth + '%';

            // Set the new values for the slider and the handle.
            // Bind mouseup events to stop dragging.
            $('.draggable_before').css('left', widthValue).on('mouseup touchend touchcancel', function () {
                $(this).removeClass('draggable_before');
                resizeElement.removeClass('resizable');
            });
            $('.resizable').css('width', widthValue);
        }).on('mouseup touchend touchcancel', function () {
            dragElement.removeClass('draggable_before');
            resizeElement.removeClass('resizable');
        });
        e.preventDefault();
    }).on('mouseup touchend touchcancel', function (e) {
        dragElement.removeClass('draggable_before');
        resizeElement.removeClass('resizable');
    });
}

//End Before After

//Product


// End Product

window.onload = function () {
    // crear_select();
}

function isMobileDevice() {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
};


var li = new Array();
var changeEvent = new Event('change');

function crear_select() {
    var div_cont_select = document.querySelectorAll("[data-mate-select='active']");
    var select_ = '';
    for (var e = 0; e < div_cont_select.length; e++) {
        div_cont_select[e].setAttribute('data-indx-select', e);
        div_cont_select[e].setAttribute('data-selec-open', 'false');
        var ul_cont = document.querySelectorAll("[data-indx-select='" + e + "'] > .cont_list_select_mate > ul");
        select_ = document.querySelectorAll("[data-indx-select='" + e + "'] >select")[0];
//         if (isMobileDevice()) {
//             select_.addEventListener('change', function () {
//                 _select_option(select_.selectedIndex,e);
//             });
//         }
        var select_optiones = select_.options;
        document.querySelectorAll("[data-indx-select='" + e + "']  > .selecionado_opcion ")[0].setAttribute('data-n-select', e);
        document.querySelectorAll("[data-indx-select='" + e + "']  > .icon_select_mate ")[0].setAttribute('data-n-select', e);
        for (var i = 0; i < select_optiones.length; i++) {

            li[i] = document.createElement('li');
            li[i].setAttribute('data-color', select_optiones[i].getAttribute('data-title'))
            li[i].setAttribute('data-index', i);
            li[i].setAttribute('data-selec-index', e);
// funcion click al selecionar
            const value = select_optiones[i].getAttribute('value');
            if (value == '/apps/retextion/#/shop/subscriptions') {
                li[i].addEventListener('click', function () {
                    document.querySelector('.rtxn_manage_subscriptions_btn').click()
                });
            } else {
                li[i].addEventListener('click', function () {
                    _select_option(this.getAttribute('data-index'), this.getAttribute('data-selec-index'));
                });
            }
            li[i].innerHTML = select_optiones[i].innerHTML;
            ul_cont[0].appendChild(li[i]);
            if (select_optiones[i].selected == true || select_.value == select_optiones[i].innerHTML) {
                li[i].className = 'active';
                document.querySelector("[data-indx-select='" + e + "']  > .selecionado_opcion ").innerHTML = select_optiones[i].innerHTML;
                document.querySelectorAll("[data-indx-select='" + e + "'] > .selecionado_opcion")[0].setAttribute("data-color", li[i].getAttribute("data-color"))
            }
            ;
        }
        ; // Fin For select_optiones
    }
    ; // fin for divs_cont_select
} // Fin Function

crear_select();


var cont_slc = 0;

function open_select(idx) {
    console.log('second open')
    var idx1 = idx.getAttribute('data-n-select');
    var ul_cont_li = document.querySelectorAll("[data-indx-select='" + idx1 + "'] .cont_select_int > li");
    var hg = 0;
    var slect_open = document.querySelectorAll("[data-indx-select='" + idx1 + "']")[0].getAttribute('data-selec-open');
    var slect_element_open = document.querySelectorAll("[data-indx-select='" + idx1 + "'] select")[0];
//     if (isMobileDevice()) {
//         if (window.document.createEvent) { // All
//             var evt = window.document.createEvent("MouseEvents");
//             evt.initMouseEvent("mousedown", false, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
//             slect_element_open.dispatchEvent(evt);
//         } else if (slect_element_open.fireEvent) { // IE
//             slect_element_open.fireEvent("onmousedown");
//         }else {
//             slect_element_open.click();
//         }
//     }else {


    for (var i = 0; i < ul_cont_li.length; i++) {
        hg += ul_cont_li[i].offsetHeight;
    }
    ;
    if (slect_open == 'false') {
        document.querySelectorAll("[data-indx-select='" + idx1 + "']")[0].setAttribute('data-selec-open', 'true');
        document.querySelectorAll("[data-indx-select='" + idx1 + "'] > .cont_list_select_mate > ul")[0].style.overflow = 'unset';
        document.querySelectorAll("[data-indx-select='" + idx1 + "'] > .icon_select_mate")[0].style.transform = 'rotate(180deg)';
    } else {
        document.querySelectorAll("[data-indx-select='" + idx1 + "']")[0].setAttribute('data-selec-open', 'false');
        document.querySelectorAll("[data-indx-select='" + idx1 + "'] > .icon_select_mate")[0].style.transform = 'rotate(0deg)';
        document.querySelectorAll("[data-indx-select='" + idx1 + "'] > .cont_list_select_mate > ul")[0].style.height = "0px";
        document.querySelectorAll("[data-indx-select='" + idx1 + "'] > .cont_list_select_mate > ul")[0].style.overflow = 'hidden';
    }
//     }

} // fin function open_select

function salir_select(indx) {
    console.log('third')
    var select_ = document.querySelectorAll("[data-indx-select='" + indx + "'] > select")[0];
    document.querySelectorAll("[data-indx-select='" + indx + "'] > .cont_list_select_mate > ul")[0].style.height = "0px";
    document.querySelector("[data-indx-select='" + indx + "'] > .icon_select_mate").style.transform = 'rotate(0deg)';
    document.querySelectorAll("[data-indx-select='" + indx + "']")[0].setAttribute('data-selec-open', 'false');
}


function _select_option(indx, selc) {
//     if (isMobileDevice()) {
//         selc = selc -1;
//     }
    var select_ = document.querySelectorAll("[data-indx-select='" + selc + "'] > select")[0];

    var li_s = document.querySelectorAll("[data-indx-select='" + selc + "'] .cont_select_int > li");
    var title = li_s[indx].getAttribute("data-color");
    var p_act = document.querySelectorAll("[data-indx-select='" + selc + "'] > .selecionado_opcion")[0].innerHTML = li_s[indx].innerHTML;
    var select_color = document.querySelectorAll("[data-indx-select='" + selc + "'] > .selecionado_opcion")[0].setAttribute("data-color", li_s[indx].getAttribute("data-color"))
    var select_optiones = document.querySelectorAll("[data-indx-select='" + selc + "'] > select > option");
    var hidden = document.querySelector('.cont_select_int');
    for (var i = 0; i < li_s.length; i++) {
        if (li_s[i].className == 'active') {
            li_s[i].className = '';
            hidden.style.overflow = 'hidden'
        }
        ;
        li_s[indx].className = 'active';

    }
    ;
    select_optiones[indx].selected = true;
    select_.selectedIndex = indx;
//     select_.onchange();
    select_.dispatchEvent(changeEvent);
    salir_select(selc);
}

// END fin function open_select

// Scroll with animation

(function ($) {


    $.fn.visible = function (partial) {

        var $t = $(this),
            $w = $(window),
            viewTop = $w.scrollTop(),
            viewBottom = viewTop + $w.height(),
            _top = $t.offset().top,
            _bottom = _top + $t.height(),
            compareTop = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;

        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
        // console.log(compareBottom <= viewBottom)
    };

})(jQuery);

var win = $(window);

var allMods = $(".module");

allMods.each(function (i, el) {
    var el = $(el);
    if (el.visible(true)) {
        el.addClass("already-visible");
    }
});

win.scroll(function (event) {

    allMods.each(function (i, el) {
        var el = $(el);
        if (el.visible(true)) {
            el.addClass("come-in");
        }
    });
});

//End Scroll


//Variant Product
$(function () {
    $('body').on('change', '.product-option-radio', function () {
        var $this = $(this);
        var $product_option_select = $this.parent().find('.product-option-select');
        var $labels = $this.parent().find('label.product-option-label');
        if ($product_option_select.length == 0) {
            var $product_option_select = $this.parents('.variant__design-position').find('.product-option-select');
            $labels = $this.parents('.variant__design-position').find('label.product-option-label');
        }

        var $currentLabel = $this.next('label.product-option-label');
        $labels.removeClass('active')
        $currentLabel.addClass('active')

        $currentLabel.data('value');
        $this.parents('form').find(".change__color-variant").text($currentLabel.data('value'));
        $this.parents('form').find(".active__variant-color").text($currentLabel.data('value'));
        $product_option_select.val(this.value);
        $product_option_select[0].dispatchEvent(new Event("change"));
        /*$product_option_select.change();*/
    })
});
// End Variant Product


//Reviews Product Page


function productReviews() {
    if ($(".jdgm-rev-widg__summary-stars").length > 0) {
        var rating = $(".jdgm-rev-widg__summary-stars").attr("aria-label");

        var rating_attr = rating.split('is')[1].split('stars')[0];
        $(".jdgm-rev-widg__summary").append("<div class='rating_reviews'>" + rating_attr + "</div>")

        var reviews_result = $('.jdgm-rev-widg__summary-text').text();
        var reviews_split = reviews_result.split('on')[1];
        if (reviews_split != undefined) {
            $(".jdgm-rev-widg__header").append("<div class='reviews_result'>" + reviews_split + "</div>");
        } else {
            $(".jdgm-rev-widg__body").css("padding", "30px");
            $(".jdgm-rev-widg__header").append("<div class='reviews_result'>" + reviews_result + "</div>");
        }
    }
}

function AllReviews() {
    var rating = $(".jdgm-all-reviews__summary-stars").attr("aria-label");
    var rating_attr = rating.split('is')[1].split('stars')[0];
    var text_change = $(".jdgm-all-reviews__summary").append("<div class='rating_reviews'>" + rating_attr + "</div>")

    var reviews_result = $('.jdgm-all-reviews__summary-text').text()
    var reviews_split = reviews_result.split('on')[1];
    var reviews_append = $(".jdgm-all-reviews__header").append("<div class='reviews_result'>" + reviews_split + "</div>")
}

function setSSText(announcementBar, title, price,oldprice,  show) {
    const content = document.querySelector('.cart-ss');
    if (content != null) {
        content.remove();
    }
    if (show) {
        const newContent = document.createElement("div");
        newContent.classList.add('cart-ss')
        newContent.innerHTML = `${title} <span class='cart-ss__text'><span class="cart-ss__text-old">${oldprice == 0 ? '' : theme.Currency.formatMoney(oldprice, theme.moneyFormat)}</span> ${oldprice == 0 ? '' : ' - '} ${price == 0 ? '' : theme.Currency.formatMoney(price, theme.moneyFormat)}</span>`;
        announcementBar.appendChild(newContent);
    }
}

const shouldDisplayAnnouncement = () => {
    const Cart = window.Rebuy.Cart
    const announcementBar = document.querySelector(".rebuy-cart__flyout-footer");
    if (announcementBar != null) {
        const titleSub = 'Subscribe & Save 10%';
        fetch(window.Shopify.routes.root + "?sections=cart-products")
            .then(res => res.json()).then((response) => {
            if (response.hasOwnProperty('cart-products')) {
                const data = response['cart-products'];
                const el = new DOMParser().parseFromString(data, 'text/html').querySelector('script');
                const cartData = JSON.parse(el.innerText);
                let newPrice = 0
                let oldPrice = 0;
                let title = titleSub;
                let showAnnouncementBar = true;
                cartData.items.forEach(el => {
                    const group = el?.product?.selling_plan_groups.find(item => item.app_id === "5859381");
                    if (el?.selling_plan_allocation == undefined && group != undefined ) {
                        title = group.name;
                        newPrice += el?.variant?.selling_plan_allocations[0].price * el.quantity;
                        oldPrice += el.final_line_price;
                    } else {
                        showAnnouncementBar = false;
                    }
                });
                setSSText(announcementBar, title, newPrice, oldPrice, showAnnouncementBar);
            }
        })

    }
}

document.addEventListener('rebuy:cart.init', function (event) {
    shouldDisplayAnnouncement();
});
document.addEventListener('rebuy:cart.ready', function (event) {
    shouldDisplayAnnouncement();
});
document.addEventListener('rebuy:cart.add', function (event) {
    shouldDisplayAnnouncement();
});
document.addEventListener('rebuy:cart.change', function (event) {
    shouldDisplayAnnouncement();
});

shouldDisplayAnnouncement();


